import { api } from '@/services/api'
import type { AxiosRequestConfig } from 'axios'

type RequestConfig = Omit<AxiosRequestConfig, 'url' | 'method' | 'data'>

export const http = {
  get: async <T>(url: string, config?: RequestConfig): Promise<T> => {
    const { data } = await api.get<T>(url, config)

    return data
  },

  post: async <T, D = unknown>(url: string, body?: D, config?: RequestConfig): Promise<T> => {
    const { data } = await api.post<T>(url, body, config)

    return data
  },

  put: async <T, D = unknown>(url: string, body?: D, config?: RequestConfig): Promise<T> => {
    const { data } = await api.put<T>(url, body, config)

    return data
  },

  patch: async <T, D = unknown>(url: string, body?: D, config?: RequestConfig): Promise<T> => {
    const { data } = await api.patch<T>(url, body, config)

    return data
  },

  delete: async <T>(url: string, config?: RequestConfig): Promise<T> => {
    const { data } = await api.delete<T>(url, config)

    return data
  },
}
